import { UPLOAD_TYPES } from '@/micros/homepage/content/utils/content-utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setContentTypeToAddReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<UPLOAD_TYPES | null>) => {
    state.contentTypeToAdd = action.payload;
  });
};

export default setContentTypeToAddReducer;
